module.exports = __webpack_public_path__ + "static/media/1.9d0b5b1e.png";